import type { ContractsTab } from "../../../common/useQueryParams";

export interface ContractTabAccess {
  canViewDataFields?: boolean | null;
  canViewDocuments?: boolean | null;
  canViewNotifications?: boolean | null;
  canViewTasks?: boolean | null;
  canViewParticipants?: boolean | null;
}

export const visibleContractTabs = (
  contract: ContractTabAccess,
): ContractsTab[] => [
  ...(contract.canViewDataFields ? (["info"] as const) : []),
  ...(contract.canViewDocuments ? (["documents"] as const) : []),
  ...(contract.canViewNotifications ? (["reminders"] as const) : []),
  ...(contract.canViewTasks ? (["tasks"] as const) : []),
  ...(contract.canViewParticipants ? (["sharing"] as const) : []),
  "dialog",
];

export const contractTabIndex = (tabs: ContractsTab[], tab: ContractsTab): number => {
  const index = tabs.indexOf(tab);
  return index === -1 ? 0 : index;
};
